// Left menu
export const LEFT_MENU_USER_MANAGEMENT = "User Management";
export const LEFT_MENU_ROLE_AND_PERMISSION = "Role and Permission";
export const LEFT_MENU_ADMINISTRATION = "Administration";
export const LEFT_MENU_MANAGE_RESOURCE = "Manage Resource";
export const LEFT_MENU_MANAGE_PACKAGE = "Manage Package";
export const LEFT_MENU_MANAGE_PRODUCT = "Manage Product";
export const LEFT_MENU_MANAGE_CAMPAIGN = "Manage Campaign";
export const LEFT_MENU_ORDER_MANAGEMENT = "Order Management";
export const LEFT_MENU_VIEW_ORDER = "View Order";
export const LEFT_MENU_VIEW_SALES = "View Sales";
export const LEFT_MENU_VIEW_ESIM = "View Esim";

// Error messages
export const ERROR_INPUT_REQUIRED = "Input required";
export const ERROR_EMAIL_IS_INVALID = "Invalid Email";
export const ERROR_PASSWORD_NOT_MATCH = "Password is not matched";
export const ERROR_PERMISSION_NOT_CHOICE = "Please select permission!";

export const EDIT_MODEL_CREATE = "CREATE";
export const EDIT_MODEL_EDIT = "EDIT";
export const EDIT_MODEL_VIEW = "VIEW";

//api status
export const API_CALL_STATUS_LOADING = "loading";
export const UPLOAD_EXCEL_SUCCESS = "Upload Excel Success";
export const UPLOAD_EXCEL_FAIL = "Upload Excel Fail";

//Upload Excel color message
export const RED = "Data rejected: update not processed.";
export const YELLOW = "Data mismatch: update will be processed.";
export const BLACK = "Data correct: update will be processed.";

// Menu id
export const MENU_CONFIG = {
  "010000": {
    id: "010000",
    name: "Administration",
    defaultAccess: "View",
    subMenus: ["010100", "010200"],
  },
  "010100": {
    id: "010100",
    name: "User Management",
    accessMap: {
      View: [4, 5],
      "View and Edit": [1, 2, 4, 5],
      "Full access": [1, 2, 3, 4, 5],
    },
  },
  "010200": {
    id: "010200",
    name: "Roles and Permission",
    accessMap: {
      View: [9, 10],
      "View and Edit": [6, 7, 9, 10],
      "Full access": [6, 7, 8, 9, 10],
    },
  },

  "020000": {
    id: "020000",
    name: "Manage Resource",
    defaultAccess: "View",
    subMenus: ["020100", "020200", "020300"],
  },
  "020100": {
    id: "020100",
    name: "Manage Package",
    accessMap: {
      "View and Edit": [11, 12, 13, 16],
      "Full access": [11, 12, 13, 14, 15, 16],
    },
  },
  "020200": {
    id: "020200",
    name: "Manage Product",
    accessMap: {
      "View and Edit": [17, 18, 19, 21],
      "Full access": [17, 18, 19, 20, 21],
    },
  },
  "020300": {
    id: "020300",
    name: "Manage Campaign",
    accessMap: {
      View: [22, 23],
      "View and Edit": [22, 23, 24, 26],
      "Full access": [22, 23, 24, 25, 26],
    },
  },
  "030000": {
    id: "030000",
    name: "Order Management",
    defaultAccess: "View",
    subMenus: ["030100", "030200", "030300"],
  },
  "030100": {
    id: "030100",
    name: "View Order",
    accessMap: {
      "Full access": [27],
    },
  },
  "030200": {
    id: "030200",
    name: "View Sales",
    accessMap: {
      "Full access": [28],
    },
  },
  "030300": {
    id: "030300",
    name: "View Esim",
    accessMap: {
      "Full access": [29],
    },
  },
};

// Label
export const LABEL_UPLOAD_FILE = "Upload File";
export const LABEL_DELETE_ASSET = "Are you sure you want to delete this file?";

// Error message
export const MESSAGE_ERROR_INPUT_REQUIRED = "Input required";

// Upload file type mapping
export const ASSET_TYPE_MAPPING = {
  package: "package",
  product: "product",
};

export const ASSET_LOCATION_MAPPING = {
  iconFileId: "icon",
  bannerFileId: "banner",
  titleImageFileId: "icon",
  campaignImageFileId: "icon",
};

// Response status
export const STATUS_CODE_RESPONSE_OK = "200";

// Api state
export const API_STATE = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

// Language options
export const LANGUAGE_OPTIONS = [
  { id: "EN", label: "EN", value: "EN" },
  { id: "CN", label: "CN", value: "CN" },
];
export const LANGUAGE_DEFAULT_OPTION = "EN";

// Language options
export const FORM_TYPE = {
  CREATE: "CREATE",
  EDIT: "EDIT",
};

export const REGION = 'REGION'

export const DOMAIN = 'BUSINESS_DOMAIN'

export const REGION_SG = 'SG'

export const COMPLETED = 'completed'

export const PERMISSION_VALUES = {
  READ: 'R',
  WRITE: 'RW',
  FULL_ACCESS: 'RWX'
};

export const MENU_IDS = {

  // Main Menu ID
  ADMINISTRATION: '010000',
  MANAGE_RESOURCE: '020000',
  ORDER_MANAGEMENT: '030000',
  // Sub Menu ID
  USER_MANAGEMENT: '010100',
  ROLE_AND_PERMISSION: '010200',
  MANAGE_PACKAGE: '020100',
  MANAGE_PRODUCT: '020200',
  MANAGE_CAMPAIGN: '020300',
  VIEW_ORDER: '030100',
  VIEW_SALES: '030200',
  VIEW_ESIM: '030300'
};

export const SUCCESS_MESSAGES = {
  USER_CREATED: 'User created successfully',
  USER_UPDATED: 'User updated successfully',
  ROLE_CREATED: 'Role created successfully',
  ROLE_UPDATED: 'Role updated successfully'
};

export const REGION_TYPE_ALL = 'ALL';
export const BOOLEAN_VALUES = {
  TRUE: 'True',
  FALSE: 'False'
};

export const DELAY_TIME = 1000;

export const PERMISSION_CONSTANTS = {
  CHECKS: {
    getJwtPattern: (menuId) => new RegExp(`\\|${menuId}-([RWX]+)\\|`),
  },
};

export const MENU_NAMES = {
  VIEW_ORDER: "View Order",
  VIEW_SALES: "View Sales",
  VIEW_ESIM: "View Esim",
  MANAGE_PACKAGE: "Manage Package",
  MANAGE_PRODUCT: "Manage Product"
};

export const ROUTES = {
  DASHBOARD_HOME: '/dashboard',
  USER_MANAGEMENT: '/dashboard/user-management',
  USER_CREATE: '/dashboard/user-management/create',
  USER_EDIT: '/dashboard/user-management/edit/:userId',
  USER_VIEW: '/dashboard/user-management/view/:userId',

  ROLE_AND_PERMISSION: '/dashboard/role-and-permission',
  ROLE_CREATE: '/dashboard/role-and-permission/create',
  ROLE_EDIT: '/dashboard/role-and-permission/edit/:roleId',
  ROLE_VIEW: '/dashboard/role-and-permission/view/:roleId',

  MANAGE_PACKAGE: '/dashboard/manage-package',
  PACKAGE_CREATE: '/dashboard/manage-package/create',
  PACKAGE_EDIT: '/dashboard/manage-package/edit/:packageId',

  MANAGE_PRODUCT: '/dashboard/manage-product',
  PRODUCT_CREATE: '/dashboard/manage-product/create',
  PRODUCT_EDIT: '/dashboard/manage-product/edit/:productId',

  MANAGE_CAMPAIGN: '/dashboard/manage-campaign',
  CAMPAIGN_CREATE: '/dashboard/manage-campaign/create',
  CAMPAIGN_EDIT: '/dashboard/manage-campaign/edit/:campaignId',

  VIEW_ORDER: '/dashboard/view-order',
  VIEW_SALES: '/dashboard/view-sales',
  VIEW_ESIM: '/dashboard/view-esim',
};